import * as actionTypes from './actionTypes';

import permissionService from '../../services/permissionService';
import { showAlert } from './uiActions';

// Fetch Permissions
export const fetchPermissions = (params = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_PERMISSIONS_REQUEST });
  try {
    const response = await permissionService.getPermissions(params);
    dispatch({
      type: actionTypes.FETCH_PERMISSIONS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PERMISSIONS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch permissions',
    });
  }
};

// Fetch Permission Modules
export const fetchPermissionModules = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_PERMISSION_MODULES_REQUEST });
  try {
    const response = await permissionService.getPermissionModules();
    dispatch({
      type: actionTypes.FETCH_PERMISSION_MODULES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PERMISSION_MODULES_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch permission modules',
    });
  }
};

// Create Permission
export const createPermission = (permissionData) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_PERMISSION_REQUEST });
  try {
    const response = await permissionService.createPermission(permissionData);
    dispatch({
      type: actionTypes.CREATE_PERMISSION_SUCCESS,
      payload: response.data,
    });
    dispatch(showAlert('Permission created successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.CREATE_PERMISSION_FAILURE,
      payload: error.response?.data?.error || 'Failed to create permission',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to create permission', 'error'));
    throw error;
  }
};

// Delete Permission
export const deletePermission = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_PERMISSION_REQUEST });
  try {
    await permissionService.deletePermission(id);
    dispatch({
      type: actionTypes.DELETE_PERMISSION_SUCCESS,
      payload: id,
    });
    dispatch(showAlert('Permission deleted successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_PERMISSION_FAILURE,
      payload: error.response?.data?.error || 'Failed to delete permission',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to delete permission', 'error'));
    throw error;
  }
};

// Fetch Single Permission
export const fetchPermission = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_PERMISSION_REQUEST });
  try {
    const response = await permissionService.fetchPermission(id);
    dispatch({
      type: actionTypes.FETCH_PERMISSION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PERMISSION_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch permission',
    });
  }
};

// Update Permission
export const updatePermission = (id, permissionData) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_PERMISSION_REQUEST });
  try {
    const response = await permissionService.updatePermission(id, permissionData);
    dispatch({
      type: actionTypes.UPDATE_PERMISSION_SUCCESS,
      payload: response.data,
    });
    dispatch(showAlert('Permission updated successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.UPDATE_PERMISSION_FAILURE,
      payload: error.response?.data?.error || 'Failed to update permission',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to update permission', 'error'));
    throw error;
  }
};

export const clearPermissionError = () => ({
  type: actionTypes.CLEAR_PERMISSION_ERROR,
});

export const clearPermissionSuccess = () => ({
  type: actionTypes.CLEAR_PERMISSION_SUCCESS,
});